import React, { useReducer, useEffect } from "react";

import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import { cPageStyles } from "./PageStyles";
import {
  cChangePasswordInitialState,
  cChangePasswordReducer,
} from "./ChangePasswordAction";
import { cUserApi } from "./UserApi";
import { encrypt, decrypt } from "./Crypto";

interface ChangePassProps {
  changePassword: boolean;
  changePasswordHandler: () => void;
  changePassDone: boolean;
  changePassDoneHandler: () => void;
  loginStateHandler: () => void;
}

const ChangePassword: React.FC<ChangePassProps> = ({
  changePassword,
  changePasswordHandler,
  changePassDone,
  changePassDoneHandler,
  loginStateHandler,
}: ChangePassProps) => {
  const classes = cPageStyles();
  const [state, dispatch] = useReducer(
    cChangePasswordReducer,
    cChangePasswordInitialState
  );

  useEffect(() => {
    if (state.username.trim() && state.curr_password.trim()) {
      dispatch({
        type: "setIsButtonDisabled",
        payload: false,
      });
    } else {
      dispatch({
        type: "setIsButtonDisabled",
        payload: true,
      });
    }
  }, [state.username, state.curr_password]);

  const getUserData = async () => {
    await cUserApi.initUserApi();
    const apiResult = await cUserApi.getUser();
    return apiResult;
  };

  const handleChangePassword = async () => {
    dispatch({
      type: "setIsButtonDisabled",
      payload: true,
    });
    console.log("In password change");
    const userData = await getUserData();
    while (userData.next()) {
      const currUser = userData.getCurrent();
      const currUserEmail = userData.getProperty("Email");
      const currUserPassword = userData.getProperty("Password");
      if (
        currUserEmail === state.username &&
        decrypt(currUserPassword) === state.curr_password
      ) {
        currUser.Password = encrypt(state.new_password);
        if (state.new_password === state.curr_password) {
          dispatch({
            type: "loginFailed",
            payload: "Old Password and New Password cannot be the same",
          });
        } else {
          if (state.new_password === state.confirm_password) {
            const updateResponse = await cUserApi.updateUser(currUser);
            if (updateResponse) {
              dispatch({
                type: "loginSuccess",
                payload: "Password Changed Successfully",
              });
              changePassDoneHandler();
              loginStateHandler();
              return;
            } else {
              dispatch({
                type: "loginFailed",
                payload: "Please Try Again",
              });
            }
          } else {
            dispatch({
              type: "loginFailed",
              payload: "Passwords Not Matched",
            });
          }
        }
      }
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.keyCode === 13 || event.which === 13) {
      state.isButtonDisabled || handleChangePassword();
    }
  };

  const handleUsernameChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    dispatch({
      type: "setUsername",
      payload: event.target.value,
    });
  };

  const handleCurrPasswordChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    dispatch({
      type: "setCurrPassword",
      payload: event.target.value,
    });
  };
  const handleNewPasswordChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    dispatch({
      type: "setNewPassword",
      payload: event.target.value,
    });
  };
  const handleConfirmPasswordChange: React.ChangeEventHandler<
    HTMLInputElement
  > = (event) => {
    dispatch({
      type: "setConfirmPassword",
      payload: event.target.value,
    });
  };
  return (
    <form className={classes.container} noValidate autoComplete="off">
      <Card className={classes.card} style={{ width: "500px" }}>
        <header className={classes.header}>
          <img src={"/image/Geminai_logo.png"} alt="" className={classes.img} />
        </header>
        <CardContent>
          <div>
            <TextField
              error={state.isError}
              fullWidth
              id="username"
              type="email"
              label="Email"
              placeholder="Email"
              margin="normal"
              onChange={handleUsernameChange}
              onKeyPress={handleKeyPress}
            />
            <TextField
              error={state.isError}
              fullWidth
              id="curr_password"
              type="password"
              label="Current Password"
              placeholder="Current Password"
              margin="normal"
              helperText={state.helperText}
              onChange={handleCurrPasswordChange}
              onKeyPress={handleKeyPress}
            />
            <TextField
              error={state.isError}
              fullWidth
              id="new_password"
              type="password"
              label="New Password"
              placeholder="New Password"
              margin="normal"
              helperText={state.helperText}
              onChange={handleNewPasswordChange}
              onKeyPress={handleKeyPress}
            />
            <TextField
              error={state.isError}
              fullWidth
              id="confirm_password"
              type="password"
              label="Confirm Password"
              placeholder="Confirm Password"
              margin="normal"
              helperText={state.helperText}
              onChange={handleConfirmPasswordChange}
              onKeyPress={handleKeyPress}
            />
          </div>
        </CardContent>
        <CardActions>
          <Button
            variant="contained"
            size="large"
            color="secondary"
            className={classes.loginBtn}
            onClick={handleChangePassword}
            disabled={state.isButtonDisabled}
          >
            Change Password
          </Button>
        </CardActions>
      </Card>
    </form>
  );
};

export default ChangePassword;
